import { create } from "zustand";

const INITIAL_COINS = 50;

export type EconomyActionSource = "reward" | "purchase" | "debug" | string;

export type PlayerEconomyState = {
  coins: number;
  totalEarned: number;
  totalSpent: number;
  addCoins: (amount: number, source?: EconomyActionSource) => void;
  spendCoins: (amount: number, source?: EconomyActionSource) => boolean;
  resetCoins: (value?: number) => void;
};

export const usePlayerEconomy = create<PlayerEconomyState>((set, get) => ({
  coins: INITIAL_COINS,
  totalEarned: INITIAL_COINS,
  totalSpent: 0,
  addCoins: (amount: number, _source?: EconomyActionSource) => {
    if (!Number.isFinite(amount) || amount === 0) {
      return;
    }

    set((state) => ({
      coins: Math.max(state.coins + amount, 0),
      totalEarned: amount > 0 ? state.totalEarned + amount : state.totalEarned,
    }));
  },
  spendCoins: (amount: number, _source?: EconomyActionSource) => {
    if (!Number.isFinite(amount) || amount <= 0) {
      return false;
    }

    const { coins } = get();
    if (coins < amount) {
      return false;
    }

    set((state) => ({
      coins: Math.max(state.coins - amount, 0),
      totalSpent: state.totalSpent + amount,
    }));

    return true;
  },
  resetCoins: (value?: number) => {
    const normalized = Number.isFinite(value) && value !== null ? Number(value) : INITIAL_COINS;

    set(() => ({
      coins: Math.max(Math.floor(normalized), 0),
      totalEarned: Math.max(Math.floor(normalized), 0),
      totalSpent: 0,
    }));
  },
}));
